module.exports = __webpack_public_path__ + "assets/img/a942e8791142cd75ff7ff8589c1e2862.svg";